<template>
    <v-dialog v-model="dialog" width="480">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" class="rounded-0" v-on="on" v-bind="attrs">수정하기</v-btn>
        </template>
        <v-card>
            <v-card-title>
                연락처 노출 여부 변경
                <v-spacer />
                <v-icon @click="dialog = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="pa-6">
                <v-row justify="center">
                    <v-col cols="auto">
                        <v-switch label="검색 공개" v-model="inputs.isDisplayed" inset hide-details class="my-0" />
                    </v-col>
                    <v-col cols="auto">
                        <v-switch label="연락처 공개" v-model="inputs.isContactDisplayed" inset hide-details class="my-0" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" class="rounded-0" @click="save">수정</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: Object,
    },
    data() {
        return {
            dialog: false,
            inputs: {
                _id: null,
                isDisplayed: false,
                isContactDisplayed: false,
            },
        };
    },
    methods: {
        reset() {
            this.inputs._id = this.value?._id;
            this.inputs.isDisplayed = this.value?.isDisplayed;
            this.inputs.isContactDisplayed = this.value?.isContactDisplayed;
        },
        async save() {
            try {
                const { expert } = await api.v1.experts.put(this.inputs);

                this.$emit("input", expert);
                this.dialog = false;
                alert("수정되었습니다.");
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    mounted() {
        this.reset();
    },
    watch: {
        dialog() {
            if (this.dialog) this.reset();
        },
    },
};
</script>

<style lang="scss">
.no-border-top {
    &,
    * {
        border-top: none !important;
    }
}
</style>
